export const ANSWERED = "ANSWERED";
export const API_FAILED = "Something went wrong, please try again or contact your provider.";
export const INBOUND = "INBOUND";
export const OUTBOUND = "OUTBOUND";
